import './AddToCartButtonContainer.scss';

import { AddToCartButton } from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Cart';
import QtyInput from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/QtyInput/QtyInput';
import React from 'react';
import compareIcon from '@progymedia/sbi-web-englander/src/images/englander-icons/Compare-Icon.svg';
import { useAvailabilityInfo } from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Cart/AddToCartButton';
import wishlistEmptyIcon from '@progymedia/sbi-web-englander/src/images/englander-icons/Wishlist-Empty-Icon.svg';

AddToCartButtonContainer.defaultProps = {
    showCartIcon: true,
};

export function AddToCartButtonContainer(props: {
    product: any;
    qtyValue: number;
    setQtyValue: any;
    small?: boolean;
    horizontalLayout?: boolean;
    setCartVisible?: boolean;
    showCartIcon?: boolean;
    showCompareAndWishList?: boolean;
}) {
    const {
        product,
        qtyValue,
        setQtyValue,
        small,
        horizontalLayout,
        setCartVisible,
        showCartIcon,
        showCompareAndWishList = false,
    } = props;
    const { allowAddToCart } = useAvailabilityInfo(product);
    const className = 'add-to-cart-button';

    return (
        <div className='addCartWrapper'>
            <div className={`addToCart ${small ? 'small' : ''}`}>
                <div className='qtyAndIcons'>
                    <QtyInput
                        product={product}
                        qtyValue={qtyValue}
                        setQtyValue={setQtyValue}
                    />
                    {showCompareAndWishList && (
                        <div className='icons'>
                            <div className='icon'>
                                <img src={compareIcon} alt='' />
                            </div>
                            <div className='icon'>
                                <img src={wishlistEmptyIcon} alt='' />
                            </div>
                        </div>
                    )}
                    {horizontalLayout && (
                        <AddToCartButton
                            className={
                                allowAddToCart
                                    ? className
                                    : `${className} disabled`
                            }
                            product={product}
                            qty={qtyValue}
                            small={small}
                            setCartVisible={setCartVisible}
                            showCartIcon={showCartIcon}
                        />
                    )}
                </div>
                {!horizontalLayout && (
                    <AddToCartButton
                        className={
                            allowAddToCart ? className : `${className} disabled`
                        }
                        product={product}
                        qty={qtyValue}
                        small={small}
                        setCartVisible={setCartVisible}
                        showCartIcon={showCartIcon}
                    />
                )}
            </div>
        </div>
    );
}
